<template>
  <div class="leave-form-wrap">
    <van-nav-bar
      right-text="历史记录"
      @click-right="$router.push('/schoolAccessAudit')"
    >
    </van-nav-bar>
    <!-- 部门-->
    <van-form validate-first :show-error="false" @submit="onSubmit">
      <div class="form-wrap">
        <van-field
          label="部门"
          size="large"
          placeholder="请选择部门"
          :rules="rules.leaveName"
          v-model="info.deptName"
          clickable
          readonly
          @click="showPicker = true"
        >
        </van-field>
      </div>
    </van-form>
    <!-- 申请主体 -->
    <van-form validate-first :show-error="false" @submit="onSubmit">
      <div class="form-wrap" v-for="(item, index) in form" :key="index">
        <div class="clear_icon" v-if="form.length != 1">
          <van-icon name="clear" @click="clear(index)" />
        </div>

        <van-field
          label="姓名"
          size="large"
          placeholder="请填写申请人姓名"
          readonly
          clickable
          @click="handleUserName(index)"
          :rules="rules.leaveName"
          v-model="item.userName"
        >
        </van-field>

        <van-field
          type="textarea"
          placeholder="请输入出入事由"
          label="出入事由"
          autosize
          v-model="item.reason"
          size="large"
        />
        <van-field
          v-model="item.outTime"
          label="出校时间段"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime('starttime', index, 'out')"
          size="large"
        />
        <!-- 入校时间段 -->
        <van-field
          v-model="item.inTime"
          label="入校时间段"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime('starttime', index, 'in')"
          size="large"
        />

        <div @click="addPerson" class="add_btn" v-if="index == form.length - 1">
          <van-icon name="add-o" style="margin-right: 3px" />
          <span>再录一个</span>
        </div>
      </div>
    </van-form>
    <!-- 审批人 -->
    <van-form validate-first :show-error="false" @submit="onSubmit">
      <div class="form-wrap">
        <van-field
          v-model="info.auditName"
          label="审批人"
          size="large"
          placeholder="请选择审批人"
          :rules="rules.leaveName"
          clickable
          readonly
          @click="$refs.interviewee.showiIntervieweePopup = true"
        >
        </van-field>
      </div>
    </van-form>
    <!-- 提交按钮 -->
    <div style="margin: 16px" @click="onSubmit">
      <van-button
        round
        block
        :loading="btn_loading"
        :disabled="btn_loading"
        type="info"
        native-type="submit"
      >
        提交
      </van-button>
    </div>
    <!-- 选择请假事项 -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        title="部门"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :currentDate="startMinTime"
      :minDate="new Date()"
      :isFilter="false"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="endMinDate"
      :isFilter="false"
      :maxDate="maxEndTime"
      :currentDate="endCurTime"
    />
    <Interviewee
      ref="interviewee"
      @selectItem="handleSelIntervieweeItem"
      pageType="teacher"
    />
    <Intervieweedept
      ref="intervieweedept"
      :deptId="info.deptId"
      @selectItem="handleSelIntervieweedeptItem"
      pageType="teacher"
    />
  </div>
</template>

<script>
import moment from "moment";
import { compare, getDateYMD, timeFormart } from "@/utils";

import Interviewee from "@/components/subScribePopup/interviewee";
import Intervieweedept from "@/components/subScribePopup/intervieweedept";
import SelectTime from "@/components/subScribePopup/selectTime";
export default {
  data() {
    return {
      info: {
        auditId: "",
        auditName: "",
        deptName: "",
        deptId: "",
      },
      handleStartTime: "",
      deptList: [],
      // 当前选中要填写入校或出校时间段
      index: "",
      form: [
        {
          userName: "",
          userId: "",
          reason: "",
          inBeginTime: "",
          inEndTime: "",
          inTime: "",
          outBeginTime: "",
          outEndTime: "",
          outTime: "",
        },
      ],
      kind: "out",
      showPicker: false,
      columns: [],
      endMinDate: "",
      startMinTime: new Date(moment().endOf("hours").add(1, "s")),
      btn_loading: false,
      childList: [],
      rules: {
        leaveType: [
          {
            required: true,
            message: "请选择事项",
            trigger: "onChange",
          },
        ],
        leaveBeginTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "onChange",
          },
        ],
        leaveEndTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "onChange",
          },
        ],
        auditName: [
          {
            required: true,
            message: "请选择审批人",
            trigger: "onChange",
          },
        ],
        // remark: [
        //   {
        //     required: true,
        //     message: "请填写备注",
        //     validator: (value, rule) => {
        //       rule.message = "输入字符大于50位";
        //       return value.length <= 50;
        //     },
        //   },
        // ],
        leaveName: [
          {
            required: true,
            message: "请填写申请人姓名",
            trigger: "onChange",
          },
        ],
      },
    };
  },

  mounted() {
    this.getDeptList();
    this.getLastLeaveDetail();
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem("userInfo")).personType;
    },
    // startMinTime() {
    //   // return new Date(moment().add(1, 'h'))
    //   return new Date(
    //     moment()
    //       .endOf('hours')
    //       .add(1, 's')
    //   )
    // },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, "h"));
    },
    endMaxTime() {
      return new Date(moment(this.endMinDate).add(this.maxDuration, "hours"));
    },
    maxEndTime() {
      return new Date(
        new Date(new Date(this.endMinDate).setHours(23, 59, 59, 999)).getTime()
      );
    },
  },
  methods: {
    // 开始时间最大选取范围
    // startTimeFW () {
    //   console.log(this.kind)
    //   return
    // },

    clear(index) {
      this.form.splice(index, 1);
    },
    open() {
      if (this.columns.length > 0) {
        showPicker = true;
        return;
      }
      this.$toast("暂无可选部门");
    },
    // 获取当前学校的部门列表
    getDeptList() {
      this.$https
        .getDeptList({
          schoolId: localStorage.getItem("schoolId"),
          status: 0,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deptList = res.data[0].children;
            this.columns = res.data[0].children.map((item) => item.deptName);
          } else {
            this.$toast(res.msg);
          }
        });

      // this.$https.getDeptList({schoolId:localStorage.getItem('schoolId'),name: '政府',status: 0}).then(res => console.log('res',res))
    },
    addPerson() {
      this.form.push({
        reason: "",
        // 入校时间段
        inBeginTime: "",
        inEndTime: "",
        inTime: "",
        // 出校时间段
        outBeginTime: "",
        outEndTime: "",
        outTime: "",
        userId: "",
        userName: "",
      });
    },
    onConfirm(value, index) {
      let newObj = this.deptList.find((item) => item.deptName == value);

      this.$set(this.info, "deptId", newObj.id);
      this.$set(this.info, "deptName", value);
      console.log("this.info", this.info);
      this.showPicker = false;
    },
    clickTime(type, idx, kind) {
      console.log("kind", kind);
      this.index = idx;
      this.kind = kind;

      this.$refs[type].showTimePopup = true;
    },
    handleTimeStartConfirm(value) {
      this.$set(this.form[this.index], `${this.kind}BeginTime`, value);
      console.log("value", value);

      this.endMinDate = new Date(value.replace(/-/g, "/"));
      this.$refs.starttime.showTimePopup = false;
      this.$refs.endtime.showTimePopup = true;
    },
    handleTimeEndConfirm(value) {
      this.$set(this.form[this.index], `${this.kind}EndTime`, value);

      // 设置显示时间
      this.$set(
        this.form[this.index],
        `${this.kind}Time`,
        `${this.form[this.index][`${this.kind}BeginTime`]} - ${value.slice(11)}`
      );
      this.$refs.endtime.showTimePopup = false;
    },
    handleSelIntervieweeItem(item) {
      // 选取部门和审批人
      this.$set(this.info, "auditId", item.id);
      this.$set(this.info, "auditName", item.name);
      this.$refs.interviewee.showiIntervieweePopup = false;
    },
    handleUserName(index) {
      if (!this.info.deptName) {
        this.$toast('请先填写申请人部门')
        return
      }
      this.index = index;
      this.$refs.intervieweedept.showiIntervieweePopup = true;
    },
    // 根据弹窗获取部门名称
    handleSelIntervieweedeptItem(item) {
      console.log("拿到人员选取的结果", item);
      this.$set(this.form[this.index], "userName", item.name);
      this.$set(this.form[this.index], "userId", item.id);
    },

    onSubmit() {
      // 对填写数据进行判断
      if (this.info.auditName == "" || this.info.deptName == "") {
        this.$toast("请将部门和审批人填写完整");
        return;
      }
      for (let item of this.form) {
        if (!item.userName) {
          console.log("12345");
          this.$toast("请填写申请人姓名");
          return;
        } else if (item.inTime == "" && item.outTime == "") {
          this.$toast("入校或出校时间至少填写一项");
          return;
        }

        item.inBeginTime && (item.inBeginTime = moment(item.inBeginTime).format('YYYY-MM-DD HH:mm:ss'))
        item.inEndTime&&(item.inEndTime = moment(item.inEndTime).format('YYYY-MM-DD HH:mm:ss'))
        item.outBeginTime&&(item.outBeginTime = moment(item.outBeginTime).format('YYYY-MM-DD HH:mm:ss'))
        item.outEndTime&& (item.outEndTime = moment(item.outEndTime).format('YYYY-MM-DD HH:mm:ss'))
      }

      // 获取提交审批的数据清单
      let req = {
        ...this.info,
        applicationUsers: this.form,
        schoolId: localStorage.getItem("schoolId"),
        submitterId: JSON.parse(localStorage.getItem("userInfo")).id,
      };
      console.log("提交申请的设备清单", req);
      this.$https
        .submitInAndOutApply(req)
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg);
            return;
          }
          this.$toast({
            type: "success",
            overlay: true,
            message: "成功",
            duration: 1500,
            onClose: () => {
              this.$router.push("/schoolAccessAudit");
            },
          });
        })
        .catch(() => {
        });
    },

    // async getAllChild() {
    //   const { code, data } = await this.$https.getAllChild({
    //     userId: this.$store.state.userId,
    //     schoolId: this.$store.state.schoolId,
    //   })
    //   if (code !== 200) {
    //     return
    //   }
    //   this.childList = [...data]
    //   this.$set(this.form, 'radio', data[0])
    // },

    async getLastLeaveDetail() {
      const { code, data } = await this.$https.getLastLeaveDetail({
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      });
      if (code !== 200) {
        return;
      }
      //   if (data.name && data.deptName) {
      //     this.$set(this.form, "auditName", `${data.name}-${data.deptName}`);
      //   }
      //   this.$set(this.form, "auditeDeptName", data.deptName);
      //   this.$set(this.form, "auditId", data.id);
      //   this.$set(
      //     this.form,
      //     "leaveBeginTime",
      //     moment().endOf("hours").add(1, "s").format("YYYY-MM-DD HH:mm")
      //   );
      //   this.startMinTime = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));
      //   this.endMinDate = new Date(this.form.leaveBeginTime.replace(/-/g, "/"));
    },
  },
  components: {
    Interviewee,
    SelectTime,
    Intervieweedept,
  },
};
</script>

<style lang="scss" scoped>
.topTitle {
  background-color: #fff;
  margin: 0 1rem 1rem;
  //   box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
.form-wrap {
  position: relative;
  margin: 1rem 1rem 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
  .clear_icon {
    position: absolute;
    right: 0;
    z-index: 2001 !important;
    top: 0;
    font-size: 1.2rem;
    background-color: #fff;
  }
  .add_btn {
    color: #646566;
    background-color: #fff;
    font-size: 1rem;
    padding: 1rem 1rem;
    text-align: center;
  }
}
</style>
